import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import WhoWeAre from '../components/WhoWeAre';
import WhatWeDo from '../components/WhatWeDo';
import Certificates from '../components/Certificates';
import Careers from '../components/Careers';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Blog from '../components/Blog';
import FloatingSocials from "../components/FloatingSocials";
import Promoted from "../components/Promoted";

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <HeroSection />
      <WhoWeAre />
      <WhatWeDo />
      <Certificates />
      <Blog />
      <Careers />
      <Contact />
      <Promoted />
      <Footer/>
      <FloatingSocials/> 
    </div>
  );
}